module.exports = ['/rules', '/card']
